const SEOData = {
  "/": {
    title: "Software Development Company Varanasi, Pune, Lucknow - Infodeltasys",
    description: "Leading app & software development services in Varanasi, Pune, and Lucknow. Boost your business with Infodeltasys expertise today.",
    ogImage: "/images/home-og.png",
  },
  "/web-design": {
    title: "Website Design Varanasi, Pune, Lucknow - Expert Web Design",
    description: "Professional web design for businesses in Varanasi, Pune, and Lucknow. Create responsive, stunning websites with Infodeltasys experts.",
    ogImage: "/images/webdesign-og.png",
  },
  "/web-development-service-company-lucknow": {
    title: "Web Development Varanasi, Pune, Lucknow - Website Experts",
    description: "Professional web development and website development services in Varanasi, Pune, and Lucknow. Build robust websites with the Infodeltasys team.",
    ogImage: "/images/webdevelopment-og.png",
  },
  "/mobile-app-development-2": {
    title: "Mobile App Development Varanasi, Pune, Lucknow Experts",
    description: "Custom mobile app development company in Varanasi, Pune, and Lucknow. Get top Android and iOS app solutions by Infodeltasys.",
    ogImage: "/images/mobileapp-og.png",
  },
  "/seo-lucknow": {
    title: "SEO Company Varanasi, Pune, Lucknow - Best SEO Services",
    description: "Top SEO company offering expert SEO services in Varanasi, Pune, and Lucknow. Boost your website rankings and traffic with Infodeltasys optimization.",
    ogImage: "/images/seo-og.png",
  },
  "/software-training": {
    title: "Software Training in Varanasi, Pune & Lucknow - Infodeltasys",
    description: "Join expert-led software training programs in Varanasi, Pune, and Lucknow. Build skills in latest software technologies with Infodeltasys training classes.",
    ogImage: "/images/softwaretraining-og.png",
  },
  "/about-us": {
    title: "About Infodeltasys - Leading Software Development Company",
    description: "Learn about Infodeltasys, a top software development company in Varanasi, Pune, and Lucknow. Discover our mission, vision, and leadership.",
    ogImage: "/images/about-us-og.png",
  },
};

export default SEOData;
